// Internal list of HTML entities for escaping.
export default {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
  '`': '&#x60;'
};



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/_escapeMap.js
// module id = 467
// module chunks = 0